'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

BreadcrumbsDirectiveController=class BreadcrumbsDirectiveController{
static get $inject(){
return['breadcrumbsService'];
}

constructor(breadcrumbsService){
this._breadcrumbService=breadcrumbsService;
}

get crumbs(){
return this._breadcrumbService.crumbs;
}};let


BreadcrumbsDirective=class BreadcrumbsDirective extends BaseControllerBackedDirective{
get templateUrl(){
return'/templates/directives/breadcrumbsDirective/breadcrumbsTemplate';
}

get controller(){
return BreadcrumbsDirectiveController;
}};


module.exports=BreadcrumbsDirective;
//# sourceMappingURL=breadcrumbsDirective.js.map
